import { options } from "./options";

export const chartjs = {
  options,
};
